import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { StyleSheet } from 'aphrodite';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';
export var styles = StyleSheet.create({
  uploadArea: {
    width: '100%',
    flex: '1 1 100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1
  },
  uploadHint: {
    textAlign: 'center',
    width: '100%',
    flex: '1 1 100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: '15px',
    boxSizing: 'border-box'
  },
  browseIcon: {
    marginBottom: '20px'
  }
});
var dragHintStyle = function dragHintStyle(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tborder-radius: 2px;\n\tmin-height: 240px;\n\tmin-width: 200px;\n\tbackground: ", ";\n"])), fromThemeColors(ThemeColor.inputBackground)(props));
};
export var StyledUploadHint = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\ttext-align: center;\n\twidth: 100%;\n\tflex: 1 1 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n\tpadding-top: 15px;\n\tbox-sizing: border-box;\n\tborder: ", ";\n\t", "\n"])), function (props) {
  return props.canDragAndDrop && "1px dashed ".concat(fromThemeColors(ThemeColor.infoBorder)(props));
}, function (props) {
  return props.canDragAndDrop ? dragHintStyle : null;
});